import hurtConsoling from '../../../../assets/svgs/actors/estherMother/hurtConsoling'
import sobbingShielding from '../../../../assets/svgs/actors/estherMother/sobbingShielding'

import {
    HURT_CONSOLING,
    SOBBING_SHIELDING,
} from '../../../../constants/scene/actors/estherMother'

export default {
    [HURT_CONSOLING]: hurtConsoling,
    [SOBBING_SHIELDING]: sobbingShielding,
}
